import { render } from "./masonary_desc.vue?vue&type=template&id=774159ba"
import script from "./masonary_desc.vue?vue&type=script&lang=js"
export * from "./masonary_desc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__